import { render, staticRenderFns } from "./projectLicence.vue?vue&type=template&id=1e0e0c13&scoped=true&"
import script from "./projectLicence.vue?vue&type=script&lang=js&"
export * from "./projectLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e0c13",
  null
  
)

export default component.exports